module.exports = __webpack_public_path__ + "img/take-mock.5a621396.svg";